import React, { useContext, useState } from "react";
import { CommandBarButton } from "sprint-common-web";

import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderListingContext } from "../../listing/context/OrderListingContext";
import { OrderListingFilters } from "../../listing/hooks/useOrderListingFilters";

export interface ExportOrdersButtonProps {
    filters: OrderListingFilters;
}

export const ExportOrdersButton: React.FC<ExportOrdersButtonProps> = ({ filters }: ExportOrdersButtonProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { pinnedItems } = useContext(OrderListingContext);

    const { exportOrders } = useOrdersModuleApi();

    const handleClick = async () => {
        setIsLoading(true);

        exportOrders({
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            statuses: filters.statuses,
            content: filters.content,
            pONumber: filters.pONumber,
            distributorId: filters.distributorId,
            airlineIds: filters.airlineIds,
            systemIds: filters.systemIds,
            orderIds: pinnedItems
        })
            .then(({ fileUrl }) => {
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", "ordersFile");
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return <CommandBarButton onClick={handleClick} text="Export" icon="Generate" isLoading={isLoading} />;
};
